import { Component } from '@angular/core';
import {CerrarSesionService} from '../app/@Common/services/login/cierre-sesion-automatico.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor (private cerrarSesion: CerrarSesionService){

  }
}
